import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FactoryPsHttpSSE } from '@patsnap-utils/sse';
import type { DocAnalyzerApi } from '../doc-analyzer-api';

@injectable()
export class DocAnalyzerApiImpl extends PsHttpService implements DocAnalyzerApi {
  @inject(FactoryPsHttpSSE)
  private _factorySsePsHttp!: FactoryPsHttpSSE;

  get options() {
    return {
      baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}`,
      headers: {
        'X-API-Version': '1.0',
      },
    };
  }

  getUsage(): Promise<Record<any, any>> {
    const baseURL = this.options.baseURL;

    return this.get<PatSnapCommonResponseData<Record<any, any>>>({
      baseURL,
      url: '/core-eurekals-api/eurekals_agent/user/usage',
    }).then((res) => {
      return res.data;
    });
  }

  uploadFile(file: File, onProgress?: (percent: number) => void): Promise<Record<any, any>> {
    const baseURL = this.options.baseURL;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('business_type', 'MSE');

    return this.post<PatSnapCommonResponseData<Record<any, any>>>({
      data: formData,
      baseURL,
      url: '/core-eurekals-api/eurekals_agent/1.0/file/upload',
      timeout: 300000,
      onUploadProgress: (progressEvent) => {
        if (!progressEvent.total) return;

        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress?.(percent);
      },
    }).then((res) => {
      return res;
    });
  }

  extractBatch(file_ids: string[]): Promise<Record<any, any>> {
    const baseURL = this.options.baseURL;

    return this.post<PatSnapCommonResponseData<Record<any, any>>>({
      data: {
        file_ids,
      },
      baseURL,
      url: '/core-eurekals-api/eurekals_agent/1.0/file/extract-batch',
    }).then((res) => {
      return res;
    });
  }

  getExample(language: string, file_id: string): Promise<Record<any, any>> {
    const baseURL = this.options.baseURL;

    return this.get<PatSnapCommonResponseData<Record<any, any>>>({
      params: {
        language,
        file_id,
      },
      baseURL,
      url: '/core-eurekals-api/eurekals_agent/1.0/file/example/upload',
    }).then((res) => {
      return res;
    });
  }
}
